import React from 'react';
import { useRoute } from '@react-navigation/native';

import { Screen } from '../../design/components';
import { GET_SERVICE_RUN_WITH_TICKET_LIST } from '../../graphql/serviceRun';
import TicketsSummaryStep from '../driver/startOfDay/TicketsSummaryStep';
import TicketSummary from './TicketSummary';

// Params: id (service run); startOfDayStep: opened from Start of day, shows the
// step's read-and-confirm summary instead of the full ticket lists.
const TicketSummaryView = () => {
	const route = useRoute();
	const id = route.params?.id;

	if (route.params?.startOfDayStep) {
		return <TicketsSummaryStep />;
	}

	return (
		<Screen heading="Tickets summary" scroll={false}>
			<TicketSummary
				id={id}
				query={GET_SERVICE_RUN_WITH_TICKET_LIST}
			/>
		</Screen>
	);
};

export default TicketSummaryView;
